interface ISponsor {
    id: string;
    industry: string | null;
    tags: string[];
    isInternal: boolean;

    /**
     * Indicates if the embedded mode is enabled, which disables personalization features like
     * Authorization and My Publications for integrations on shared devices, ensuring a streamlined
     * and privacy-conscious experience for users.
     */
    isEmbeddedModeEnabled: boolean;
    isNotificationEnabled: boolean;
    hideRadiantPeriodTimer: boolean;
    isHotspotEnabled: boolean;
    isHotspotActive: boolean;
    isGeoLocationValidationEnabled: boolean;
    /** Internal Name of the Sponsor. Should not be used on UI. */
    name: string | null;

    /** Values from HotSpot->Notifications in HUB */
    notifications: {
        broughtBy: string | null;
        complimentaryAccess: string | null;
        featuredCarouselTitle: string | null;
        sponsoredBy: string | null;
        welcomeMessageTitle: string | null;
        welcomeMessageBody: string | null;
        complimentaryAccessRemainingTime: string | null;
    };

    radiantPeriod?: { startDate: Date; endDate: Date };
    expiredHotspot?: {
        showExpiredHotspot: boolean;
        siteId: number;
    };

    status?: SponsorshipStatus;
    commands: SponsorshipCommand[];
}

enum SponsorshipStatus {
    Off = 0,
    Busy = 1,
    On = 2,
    BusyLimitExceeded = 3,
    OutOfHotspot = 4,
}

interface SponsorshipCommand {
    Data: {
        Data: string;
    };
    Name: string;
    Params: {
        FeaturedTitles: string[];
        RadiantInfo: {
            RadiantPeriod: {
                Start: string;
                End: string;
            };
        };
        IssuesInfo: {
            Issues: {
                Remaining: number;
            };
        };
        Documents?: unknown;
    };
}

export { ISponsor, SponsorshipCommand, SponsorshipStatus };
